import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-[#f4f4f0] font-sans">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 py-20 sm:py-28">
        <Link
          to="/"
          data-testid="privacy-back-link"
          className="inline-flex items-center gap-2 text-[11px] tracking-[0.25em] uppercase text-[#a1a1aa] hover:text-[#D4AF37] transition-colors"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Back to site
        </Link>

        <p className="overline mt-12">Legal</p>
        <h1 className="headline text-4xl sm:text-5xl text-[#f4f4f0] mt-4">
          Privacy Notice
        </h1>
        <div className="divider-gold my-8" />

        <div className="space-y-6 text-[#a1a1aa] leading-relaxed text-[15px] sm:text-base">
          <p className="text-[#71717a] text-xs tracking-[0.2em] uppercase">
            Last updated: {new Date().toLocaleDateString("en-GB", { month: "long", year: "numeric" })}
          </p>

          <h2 className="font-serif text-2xl text-[#f4f4f0] pt-4">
            Who we are
          </h2>
          <p>
            This website is operated by Mateo Bryson, a private mobile
            personal trainer based in Chelsea, London (&ldquo;we&rdquo;,
            &ldquo;us&rdquo;). If you have any questions about this notice or
            your personal data, contact{" "}
            <a
              href="mailto:mateobrysonpt@gmail.com"
              className="text-[#D4AF37] hover:underline"
            >
              mateobrysonpt@gmail.com
            </a>{" "}
            or call{" "}
            <a
              href="tel:07386710866"
              className="text-[#D4AF37] hover:underline"
            >
              07386 710 866
            </a>
            .
          </p>

          <h2 className="font-serif text-2xl text-[#f4f4f0] pt-4">
            What we collect
          </h2>
          <p>
            When you submit the enquiry form we collect the details you
            provide: your name, email address, phone number (optional), goal
            (optional) and message. We do not use advertising cookies or
            third-party trackers beyond basic, aggregated analytics.
          </p>

          <h2 className="font-serif text-2xl text-[#f4f4f0] pt-4">
            How we use your data
          </h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>To respond to your enquiry and arrange a consultation.</li>
            <li>
              To send a one-off notification email to the trainer
              (mateobrysonpt@gmail.com) via Resend, our transactional email
              provider.
            </li>
            <li>To keep a private record of enquiries for service delivery.</li>
          </ul>
          <p>
            We do not sell, share, or pass your details to any marketing list.
          </p>

          <h2 className="font-serif text-2xl text-[#f4f4f0] pt-4">
            Lawful basis (UK GDPR)
          </h2>
          <p>
            We process your data on the basis of{" "}
            <em>legitimate interest</em> (responding to an enquiry you
            initiated) and, where relevant, <em>contract</em> (preparing or
            delivering personal training services you&rsquo;ve engaged).
          </p>

          <h2 className="font-serif text-2xl text-[#f4f4f0] pt-4">
            How long we keep it
          </h2>
          <p>
            Enquiry records are retained for up to 24 months, after which
            they are deleted unless you have become an active client (in
            which case they&rsquo;re held for the duration of our working
            relationship plus 6 years for accounting purposes).
          </p>

          <h2 className="font-serif text-2xl text-[#f4f4f0] pt-4">
            Your rights
          </h2>
          <p>
            You have the right to access, correct, or delete your personal
            data, to restrict or object to processing, and to lodge a
            complaint with the UK Information Commissioner&rsquo;s Office
            (ico.org.uk). To exercise any of these rights, email{" "}
            <a
              href="mailto:mateobrysonpt@gmail.com"
              className="text-[#D4AF37] hover:underline"
            >
              mateobrysonpt@gmail.com
            </a>
            .
          </p>

          <h2 className="font-serif text-2xl text-[#f4f4f0] pt-4">
            Third parties
          </h2>
          <p>
            We use <strong>Resend</strong> (resend.com) to deliver
            notification emails and <strong>MongoDB Atlas</strong> to store
            enquiry records securely. Both providers operate under
            appropriate data-protection safeguards.
          </p>

          <h2 className="font-serif text-2xl text-[#f4f4f0] pt-4">
            Changes
          </h2>
          <p>
            We may update this notice from time to time. The &ldquo;last
            updated&rdquo; date at the top of the page will reflect the most
            recent revision.
          </p>
        </div>

        <div className="mt-16 pt-10 border-t border-white/10">
          <Link
            to="/"
            data-testid="privacy-home-link"
            className="inline-flex items-center gap-2 border border-white/20 text-[#f4f4f0] px-6 py-3 text-[11px] tracking-[0.25em] uppercase hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
          >
            Return home
          </Link>
        </div>
      </div>
    </div>
  );
}
